export default __webpack_public_path__ + "static/media/2.c4237ca4.png";